import { useEffect, useState } from "react";

// Phone breakpoint for the landing page's mobile-specific structure
// (client, 2026-09-17): under 768px the hero drops the wordmark morph, the
// ticker is not rendered, and sections use their phone layouts.
export const PHONE_QUERY = "(max-width: 767px)";

export function useIsPhone() {
  const [phone, setPhone] = useState(() => typeof window !== "undefined" && window.matchMedia(PHONE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = (e) => setPhone(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);
  return phone;
}
